import React from "react";
import GenerateNoteAction from "./GenerateNoteAction";
import GenerateTranscriptAction from "./GenerateTranscriptAction";
import MissingNotesAction from "./MissingNotesAction";
import MoveTranscriptAction from "./MoveTranscriptAction";
import TestNoteAction from "./TestNoteAction";
import UploadTo4dAction from "./UploadTo4dAction";
import { isCapabilityEnabled } from "../../config/capabilities";
import SupportSection from "./SupportSection";
import { FOUR_D_IMPORT_TYPE, isNoteLocked } from "./patientActionConfig";
import ActionSubpanel from "./ActionSubpanel";

const PatientActions = ({ patient, refreshKey = 0 }) => {
  if (!patient?.patient_id) return null;

  const showUploadTo4d =
    isCapabilityEnabled("uploadTo4d") &&
    patient.import_type === FOUR_D_IMPORT_TYPE;
  const showMoveTranscript = isCapabilityEnabled("moveTranscript");
  const showMissingNotes = isCapabilityEnabled("sentryActivity");
  const toolNames = [
    "Transcript Generation",
    "Note Generation",
    showMoveTranscript && "Move Transcript",
    showUploadTo4d && "4D EMR",
    showMissingNotes && "Missing Notes",
  ].filter(Boolean);

  return (
    <SupportSection
      title="Actions"
      summary={toolNames.join(", ")}
      defaultOpen={false}
    >
      <div className="space-y-3">
        <ActionSubpanel
          id="action-transcript-generation"
          title="Transcript Generation"
          summary="Generate a transcript from audio"
        >
          <GenerateTranscriptAction patient={patient} />
        </ActionSubpanel>
        <ActionSubpanel
          id="action-note-generation"
          title="Note Generation"
          summary="Regenerate or test the note"
          contentClassName="p-3 flex flex-wrap items-center gap-2"
        >
          {isNoteLocked(patient.status) ? (
            <p className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-3 py-2">
              This note is Locked, so it cannot be edited or regenerated.
            </p>
          ) : (
            <GenerateNoteAction patientId={patient.patient_id} />
          )}
          <TestNoteAction patientId={patient.patient_id} finalNote={patient.note} />
        </ActionSubpanel>
        {showMoveTranscript && (
          <ActionSubpanel
            id="action-move-transcript"
            title="Move Transcript"
            summary="Fix a transcript recorded under the wrong patient"
          >
            <MoveTranscriptAction patient={patient} />
          </ActionSubpanel>
        )}
        {showUploadTo4d && (
          <ActionSubpanel
            id="action-upload-4d"
            title="4D EMR"
            summary="Upload the note to 4D"
          >
            <UploadTo4dAction patient={patient} />
          </ActionSubpanel>
        )}
        {showMissingNotes && (
          <ActionSubpanel
            id="action-missing-notes"
            title="Missing Notes"
            summary="Analyze Sentry logs to check if a recording happened"
          >
            <MissingNotesAction patient={patient} refreshKey={refreshKey} />
          </ActionSubpanel>
        )}
      </div>
    </SupportSection>
  );
};

export default PatientActions;
